(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-video-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CstmVideoLoaded) return;
    window.CstmVideoLoaded = true;

    class CstmVideo {
      constructor(root) {
        this.root = root;
        const d = root.dataset;
        this.provider = d.provider;
        this.vid = d.videoId;
        this.autoplay = d.autoplay === 'true';
        this.pauseOut = d.pauseOut === 'true';
        this.loop = d.loop === 'true';
        this.controls = d.controls === 'true';
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.player = root.querySelector('.cstm-video__player');
        this.video = root.querySelector('video');
        this.embed = root.querySelector('[data-cstm-embed]');
        this.hit = root.querySelector('[data-cstm-hit]');
        this.toggleBtn = root.querySelector('[data-cstm-action="toggle"]');
        this.soundBtn = root.querySelector('[data-cstm-action="sound"]');

        this.iframe = null;
        this.started = false;
        this.playing = false;
        this.muted = this.video ? this.video.muted : false;
        this.userPaused = false;
        this.autoPaused = false;

        if (!this.provider || !this.hit) return;
        this.bind();
      }

      bind() {
        this.hit.addEventListener('click', () => this.toggle());
        if (this.toggleBtn) this.toggleBtn.addEventListener('click', (e) => { e.stopPropagation(); this.toggle(); });
        if (this.soundBtn) this.soundBtn.addEventListener('click', (e) => { e.stopPropagation(); this.toggleSound(); });

        if (this.video) {
          this.video.addEventListener('play', () => this.setState(true, true));
          this.video.addEventListener('pause', () => {
            if (this.video.ended) return;
            if (!this.autoPaused) this.userPaused = true;
            this.autoPaused = false;
            this.setState(false);
          });
          this.video.addEventListener('ended', () => {
            this.userPaused = true;
            this.setState(false);
          });
          this.video.addEventListener('volumechange', () => {
            this.muted = this.video.muted;
            this.updateSound();
          });
        }

        if ('IntersectionObserver' in window) {
          new IntersectionObserver((entries) => {
            entries.forEach((en) => this.onView(en.isIntersecting));
          }, { threshold: 0.5 }).observe(this.player);
        }
      }

      onView(visible) {
        if (visible) {
          if (this.autoplay && !this.userPaused && !this.playing && !this.reduceMotion) this.play(true);
        } else if (this.pauseOut && this.playing) {
          this.autoPaused = true;
          this.pause();
        }
      }

      setState(playing, started) {
        this.playing = playing;
        if (started) this.started = true;
        this.root.classList.toggle('is-playing', playing);
        this.root.classList.toggle('is-started', this.started);
        this.hit.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
        this.updateSound();
      }

      toggle() {
        if (this.playing) {
          this.userPaused = true;
          this.pause();
        } else {
          this.userPaused = false;
          this.play(false);
        }
      }

      play(auto) {
        if (!this.started) this.muted = auto ? true : false;

        if (this.provider === 'shopify') {
          this.video.muted = this.muted;
          const p = this.video.play();
          if (p && p.catch) p.catch(() => {});
        } else if (!this.iframe) {
          this.buildIframe();
        } else {
          this.cmd('play');
          this.setState(true, true);
        }
      }

      pause() {
        if (this.provider === 'shopify') {
          this.video.pause();
        } else {
          this.cmd('pause');
          this.setState(false);
        }
      }

      toggleSound() {
        this.muted = !this.muted;
        if (this.video) this.video.muted = this.muted;
        else this.cmd(this.muted ? 'mute' : 'unmute');
        this.updateSound();
      }

      updateSound() {
        if (!this.soundBtn) return;
        this.soundBtn.classList.toggle('is-muted', this.muted);
        this.soundBtn.setAttribute('aria-label', this.muted ? 'Unmute video' : 'Mute video');
      }

      buildIframe() {
        const id = encodeURIComponent(this.vid);
        let src;
        if (this.provider === 'youtube') {
          const p = new URLSearchParams({
            autoplay: 1,
            mute: this.muted ? 1 : 0,
            controls: this.controls ? 1 : 0,
            playsinline: 1,
            rel: 0,
            modestbranding: 1,
            enablejsapi: 1,
            origin: window.location.origin
          });
          if (this.loop) { p.set('loop', 1); p.set('playlist', this.vid); }
          src = 'https://www.youtube-nocookie.com/embed/' + id + '?' + p.toString();
        } else {
          const p = new URLSearchParams({
            autoplay: 1,
            muted: this.muted ? 1 : 0,
            controls: this.controls ? 1 : 0,
            loop: this.loop ? 1 : 0,
            playsinline: 1,
            title: 0,
            byline: 0,
            portrait: 0,
            dnt: 1
          });
          src = 'https://player.vimeo.com/video/' + id + '?' + p.toString();
        }

        const f = document.createElement('iframe');
        f.src = src;
        f.title = 'Video player';
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        f.allowFullscreen = true;
        f.addEventListener('load', () => this.setState(true, true), { once: true });
        this.embed.appendChild(f);
        this.iframe = f;
      }

      cmd(action) {
        if (!this.iframe || !this.iframe.contentWindow) return;
        const w = this.iframe.contentWindow;
        if (this.provider === 'youtube') {
          const map = { play: 'playVideo', pause: 'pauseVideo', mute: 'mute', unmute: 'unMute' };
          w.postMessage(JSON.stringify({ event: 'command', func: map[action], args: [] }), '*');
        } else {
          const map = {
            play: { method: 'play' },
            pause: { method: 'pause' },
            mute: { method: 'setVolume', value: 0 },
            unmute: { method: 'setVolume', value: 1 }
          };
          w.postMessage(JSON.stringify(map[action]), '*');
        }
      }
    }

    const init = (root) => { if (!root.__cstmVideo) root.__cstmVideo = new CstmVideo(root); };
    const initAll = (ctx) => (ctx || document).querySelectorAll('[data-cstm-video]').forEach(init);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
    else initAll();

    document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-video-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var canHover = window.matchMedia('(hover: hover)');

  function initSection(root) {
    if (!root || root.__ugcReady) return;
    var track = root.querySelector('[data-ugc-track]');
    if (!track) return;
    root.__ugcReady = true;

    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-ugc-card]'));
    var prev = root.querySelector('[data-ugc-prev]');
    var next = root.querySelector('[data-ugc-next]');
    var dotsEl = root.querySelector('[data-ugc-dots]');
    var opts = {
      autoplay: root.dataset.autoplay === 'true',
      delay: (parseInt(root.dataset.delay, 10) || 5) * 1000,
      loop: root.dataset.loop === 'true',
      step: root.dataset.step || 'slide',
      single: root.dataset.single === 'true',
      hoverPlay: root.dataset.hoverPlay === 'true',
      muted: root.dataset.muted === 'true'
    };

    /* ---------- Video ---------- */
    function setState(card, playing) {
      card.setAttribute('data-playing', playing ? 'true' : 'false');
      var btn = card.querySelector('[data-ugc-toggle]');
      if (btn) {
        btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
        btn.setAttribute('aria-label', btn.getAttribute(playing ? 'data-label-pause' : 'data-label-play'));
      }
    }

    function pauseCard(card) {
      var v = card.querySelector('video');
      if (v && !v.paused) v.pause();
    }

    function playCard(card) {
      var v = card.querySelector('video');
      if (!v) return;
      var p = v.play();
      if (p && p.catch) p.catch(function () { setState(card, false); });
    }

    cards.forEach(function (card) {
      var v = card.querySelector('video');
      if (!v) return;

      v.addEventListener('play', function () {
        setState(card, true);
        if (opts.single) {
          cards.forEach(function (c) {
            if (c !== card) { delete c.dataset.preview; pauseCard(c); }
          });
        }
      });
      v.addEventListener('pause', function () { setState(card, false); });
      v.addEventListener('ended', function () { setState(card, false); });

      card.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        /* Click during a hover preview "locks" it: keep playing, restore sound */
        if (card.dataset.preview === 'true') {
          delete card.dataset.preview;
          if (!opts.muted) v.muted = false;
          return;
        }
        if (v.paused) playCard(card); else pauseCard(card);
      });

      if (opts.hoverPlay) {
        card.addEventListener('mouseenter', function () {
          if (!canHover.matches || !v.paused) return;
          v.muted = true;
          card.dataset.preview = 'true';
          playCard(card);
        });
        card.addEventListener('mouseleave', function () {
          if (card.dataset.preview === 'true') {
            delete card.dataset.preview;
            pauseCard(card);
            v.currentTime = 0;
          }
        });
      }
    });

    /* ---------- Slider ---------- */
    function isSlider() {
      return getComputedStyle(root).getPropertyValue('--ugc-mode').trim() === 'slider';
    }
    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }
    function stepPx() {
      if (opts.step === 'page') return track.clientWidth;
      var c = cards[0];
      if (!c) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return c.offsetWidth + gap;
    }
    function go(dir, wrap) {
      var max = maxScroll();
      var x = track.scrollLeft;
      var target = x + dir * stepPx();
      if ((opts.loop || wrap) && dir > 0 && x >= max - 2) target = 0;
      else if (opts.loop && dir < 0 && x <= 2) target = max;
      track.scrollTo({
        left: Math.max(0, Math.min(max, target)),
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
    }
    function buildDots(n) {
      dotsEl.innerHTML = '';
      var label = dotsEl.getAttribute('data-label') || 'Go to slide';
      for (var i = 0; i < n; i++) {
        (function (i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ugc__dot';
          b.setAttribute('aria-label', label + ' ' + (i + 1));
          b.addEventListener('click', function () {
            var m = maxScroll();
            track.scrollTo({
              left: n === 1 ? 0 : (i / (n - 1)) * m,
              behavior: reduceMotion.matches ? 'auto' : 'smooth'
            });
          });
          dotsEl.appendChild(b);
        })(i);
      }
    }
    function update() {
      var slider = isSlider();
      var max = maxScroll();
      var overflow = slider && max > 2;
      root.setAttribute('data-overflow', overflow ? 'true' : 'false');
      if (!overflow) return;
      var x = track.scrollLeft;
      if (prev) prev.disabled = !opts.loop && x <= 2;
      if (next) next.disabled = !opts.loop && x >= max - 2;
      if (dotsEl) {
        var n = Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth - 0.02));
        if (dotsEl.children.length !== n) buildDots(n);
        var idx = n === 1 ? 0 : Math.round((x / max) * (n - 1));
        for (var i = 0; i < dotsEl.children.length; i++) {
          if (i === idx) dotsEl.children[i].setAttribute('aria-current', 'true');
          else dotsEl.children[i].removeAttribute('aria-current');
        }
      }
    }

    var raf = null;
    function schedule() {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; update(); });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(track);
    update();

    /* ---------- Autoplay ---------- */
    var hovering = false;
    var inView = true;
    function anyPlaying() {
      return cards.some(function (c) { return c.getAttribute('data-playing') === 'true'; });
    }
    if (opts.autoplay && !reduceMotion.matches) {
      root.addEventListener('mouseenter', function () { hovering = true; });
      root.addEventListener('mouseleave', function () { hovering = false; });
      root.addEventListener('focusin', function () { hovering = true; });
      root.addEventListener('focusout', function () { hovering = false; });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
        }).observe(root);
      }
      root.__ugcTimer = setInterval(function () {
        if (!isSlider() || hovering || !inView || document.hidden || anyPlaying() || maxScroll() <= 2) return;
        go(1, true);
      }, opts.delay);
    }

    /* Theme editor: scroll selected block into view */
    root.addEventListener('shopify:block:select', function (e) {
      if (isSlider()) track.scrollTo({ left: e.target.offsetLeft, behavior: 'auto' });
    });
  }

  function initAll(ctx) {
    (ctx || document).querySelectorAll('[data-ugc]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector('[data-ugc]');
    if (r && r.__ugcTimer) clearInterval(r.__ugcTimer);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
